export enum ActiveHealthPolicyMenuEnum {
  PERSONAL = 'personal',
  PREMIUM = 'premium',
  ACTIVITY = 'activity',
  DEVICE = 'device',
}
